export default __webpack_public_path__ + "static/media/6-1.665d17ce.jpg";